<template>
  <div>
    <p id="smile-kv"><img src="@/assets/img/ico_home_smiles.png" alt="SMILES"></p>
    <main class="mt00">
     <h2 id="ttl-service">
       <span class="txt-en">Japan's No.1 mobile international money transfer service</span><br>
       日本国内No.1モバイル国際送金サービス
      </h2>
      <p class="txt-service">
       Why Smiles is The No.1 international money transfer service?
        <ul>
          <li>High exchange rate and affordable fee</li>
          <li>Full customer support</li>
          <li>Fast and reliable 24/7 service</li>
          <li>World-class fintech platform with esteemed partners</li>
          <li>Unique custom reward programs</li>
        </ul>
      "Sending money to your family provides ultimates happiness" Our team value your hard-earned income, and, we are delighted to share your happiness in helping your families and countries<br><br>

      &#9312; Create an account<br>
      &#9313; Make a deposit<br>
      &#9314; Send money<br>
      </p>

      <p class="txt-service">
       国際送金No.1としてえらば選ばれたのは？
        <ul>
          <li>有利な為替レート&お手頃な送金手数料</li>
          <li>充実のカスタマーサポート</li>
          <li>早くて信頼性の高い24時間365日サービス</li>
          <li>各国のパートナーと連携するグローバルなFinTechプラットフォーム</li>
          <li>独自のユーザー特典プログラム</li>
        </ul>
      「家族にお金を送ることで、より幸せになる」私たちのサービス基準を保つことで、あなたの大事なお金に余分なコスト負担をさせず、あなたのスマイルを守ります。<br><br>

      &#9312; アカウントを作成して<br>
      &#9313; 入金して<br>
      &#9314; 送金する<br>
      </p>

      <p class="btn-service"><router-link to="" @click.native="clickLink">Read More</router-link></p>
    </main>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  data () {
    return {
      db: firebase.firestore(),
      uid :firebase.auth().currentUser.uid,
      path: "https://www.smileswallet.com/",
      name: "SMILES",
    }
  },
  methods: {
    clickLink () {
      this.db.collection("service_link_click_histories").add({
        user_id : this.uid,
        name: this.name,
        clicked_at : firebase.firestore.FieldValue.serverTimestamp(),
      })
      open(this.path, "_blank")
    },
  },
}
</script>
